<div class="assets-update">
	<asset-table
		[assets]="company.assets"
		[enableCustomRowAction]="true"
		[enableFollowCheckbox]="false"
		[enableAssetNav]="false"
		[customRowAction]="openAsset.bind(this)"
		[initialColumns]="assetColumns"
		[updateMode]="selfUpdateMode"
	></asset-table>
</div>
